import { render, staticRenderFns } from "./DocumentsUserLayout.vue?vue&type=template&id=5fd2bd7e&"
import script from "./DocumentsUserLayout.vue?vue&type=script&lang=js&"
export * from "./DocumentsUserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports